import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export const STATSIG_DEFAULT_MARKETPLACE_EXPERIMENTS = {
  marketplaceTestExperimentForStatsigInt: false
};
export const STATSIG_DEFAULT_MARKETPLACE_FEATURE_FLAGS = {
  enableStaffPickOnAppListing: false
};

/* Default values for each of the feature flags from `MarketplaceFeatureFlags`. */
export const DEFAULT_MARKETPLACE_FEATURE_FLAGS = _objectSpread(_objectSpread({
  replaceCategoriesOnAppTilesWithVendorName: false,
  hideInstallDownloadCountsEnabled: false,
  showAppRequestPlaceholder: false,
  sortingLogicForCategoryFilter: 'default',
  enableRequestAppCtaCopyChange: false,
  enableBugBountyProgram: false,
  enableTrialExpiryBanner: false,
  enableCloudFortifiedAppsDiscovery: false,
  enableWebpImage: false,
  showCustomBackendErrorsFromUpm: false,
  enableFreeStarterTierFilter: false,
  disableAppInstall: false,
  showManageAppRequestAlternativeLayout: false,
  spaRoutingForPartnerApps: false,
  spaRoutingForPartnerDetails: false,
  spaRoutingForPartnerPayment: false,
  disableAllHostingFromPromotionsDropdown: false,
  spaRoutingForPartnerReports: false,
  reviewsCompliancePrompt: false,
  displayAuditTabInManagePartnerPage: true,
  useAmktFrontendAthreosManagePartners: false,
  enableUpdateByCatalogServiceCall: false,
  enableInContextAppRequest: false,
  showCompatibleSiteProducts: false,
  enableInProductHelpPartnerReporting: false,
  showTrelloProductFilter: false,
  strideHipchatBanners: false,
  showTrustSignalsInManageAppRequests: false,
  showDatePickerOnManagePricingTab: false,
  enableLogAccessByDefaultMessage: false,
  showBenchmarkingUiDropdown: false,
  showDecomposedReviews: false,
  showQualtricsSurvey: false,
  enableRetryForLicenseDetailsPostInstallation: false,
  enableEmailSubscription: false,
  allowSectionMessageForPartnersForMigrationToCcp: [],
  enableIncludePartnerForAllowSectionMessageForMigrationToCcp: false,
  showAppListingTrustTab: false,
  displayPrivacyAndSecurityPreviewTab: false,
  enableReactivateForgeAppFromEmcee: false,
  enableReactivateForgeAppFromEmceeForHAMS: false,
  enableGoogleAnalytics4Tracking: false,
  enableUserSessionAuthForMpacToEmceeRedirect: false,
  enableNewPartnerContactRole: false,
  showCopyChangesForPartnerContact: false,
  enableDualLicenseToggleInPartnersTable: false,
  enableCloudMigrationToggle: false,
  enableReviewComplianceUi: false,
  enablePrefixCodeSectionForGenericCloudPromotions: false,
  enablePromoCodeUniquenessCheck: false,
  enableBacRedirectionForCcpPromotions: false,
  allowSectionMessageForCCPPromotionMigration: false,
  enableMpacServerEolWarning: false,
  enableJsdToJsm: false,
  enableReportsV2FeedbackCollector: false,
  enableReportsAccessibilityChanges: false,
  showPricingAnnouncementAlert: false,
  enableFiftyKTiersForAllApps: false,
  enableFiftyKPricingTiers: false,
  enableForgeEgressAddressesOnInstallScreen: false,
  enableHostingSelectionModal: true,
  showAlternativeRatingsComponent: false,
  pollIntervalForConnectApps: 300,
  serverEolAppsWithDcVersion: [],
  showAppSlugInAppListingUrl: false,
  showAiAppsCollectionTile: false,
  useAnalyticsWebClient: false,
  showRatingsByHostingType: false,
  enableServerEolWarningForBambooAndCrowd: false,
  enableSenDeprecationChanges: false,
  enableDeprecatedInstallationsGQL: false,
  enableAetherSearchExperience: false,
  consumePartnerUserApi: false,
  enableServerEos: false
}, STATSIG_DEFAULT_MARKETPLACE_FEATURE_FLAGS), STATSIG_DEFAULT_MARKETPLACE_EXPERIMENTS);